var React = require('react');

function IconRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".icon-right{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}")),React.createElement("g",{"id":"TAYLOR-MADE","key":1},React.createElement("g",{"id":"S4"},React.createElement("g",null,[React.createElement("circle",{"className":"icon-right","cx":"27.5","cy":"27.5","r":"26.5","key":0}),React.createElement("line",{"className":"icon-right","x1":"28","y1":"40","x2":"28","y2":"15","key":1}),React.createElement("line",{"className":"icon-right","x1":"44","y1":"27","x2":"28","y2":"27","key":2})])))]);
}

IconRight.defaultProps = {"id":"Layer_2","viewBox":"0 0 55 55"};

module.exports = IconRight;

IconRight.default = IconRight;
